<template>
  <main ref="loader" class="case-study">
    <div v-if="blocks">
      <BlockWave
        v-bind="{
          enabled: true,
          position: {
            x: 25,
            y: -33
          },
          color: $colours['waveBlue'],
          rotate: 45,
          alignment: {
            x: 'left'
          }
        }"
      >
        <BlockWave
          v-bind="{
            enabled: true,
            position: {
              x: 150,
              y: 150
            },
            color: $colours['waveBlue'],
            rotate: 180,
            alignment: {
              x: 'right'
            }
          }"
          @mask="heroMask = $event"
        >
          <BlockHero :block="hero" />
        </BlockWave>
      </BlockWave>
      <BlockWave
        :enabled="true"
        :color="$colours['waveBlue']"
        :maskData="heroMask"
      >
        <BlockWave v-bind="waveApiToComponentCoupler(content.wave['1'])">
          <BlockWave v-bind="waveApiToComponentCoupler(content.wave['2'])">
            <div class="case-study__blocks">
              <div
                v-for="block in blocks"
                :key="block.id"
                :class="`block-${block.type.toLowerCase()}-wrapper`"
              >
                <BlockInnerCard v-if="block.type === 'Card'" :block="block" />
                <BlockQuote v-if="block.type === 'Quote'" :block="block" />
                <div
                  v-if="block.type === 'Text'"
                  v-html="block.text"
                  class="case-study__text"
                />
                <div v-if="block.type === 'Image'" class="case-study__image">
                  <img
                    :src="block.images[0].src"
                    :alt="block.images[0].alt"
                    :srcset="block.images[0].srcset"
                  />
                </div>
              </div>
            </div>
          </BlockWave>
        </BlockWave>
      </BlockWave>
      <BlockWave
        v-bind="{
          enabled: true,
          type: 4,
          position: {
            x: 0,
            y: 0
          },
          color: $colours['waveLightBlue']
        }"
      >
        <BlockStats
          :block="content.statisticGroup"
          :prev="content.previousCaseStudy"
          :next="content.nextCaseStudy"
        />
      </BlockWave>
    </div>
  </main>
</template>

<script>
import { loader, maskBus } from '@/mixins';
import BlockWave, { fallback } from '@/components/Block/BlockWave';

import {
  BlockHero,
  BlockInnerCard,
  BlockQuote,
  BlockStats
} from '@/components/Block';

export default {
  name: 'CaseStudy',
  components: {
    BlockHero,
    BlockInnerCard,
    BlockQuote,
    BlockStats,
    BlockWave
  },
  data: () => {
    return {
      content: null,
      heroMask: fallback
    };
  },
  mixins: [loader, maskBus],
  computed: {
    hero() {
      return {
        heading: this.content ? this.content.title : null,
        media: this.content ? this.content.media : null,
        options: {
          backgroundColour: 'cream',
          fullWidth: true,
          caseStudy: true
        }
      };
    },
    blocks() {
      return this.content ? this.content.pageGroup : null;
    }
  },
  methods: {
    getContent(to) {
      const slug = to ? to : this.$route.params.slug;
      this.$http
        .get(`/api/v1/case-study/${slug}.json?i=1`)
        .then(response => {
          this.content = response.data.data[0];
        })
        .catch(error => console.error(error));
    }
  }
};
</script>

<style lang="postcss">
.case-study {
  &__blocks {
    @apply relative;
    /* @apply bg-brand-cream; */
    @apply z-40;
    @apply pb-32;
    /* @apply z-20; */
    .block-card-wrapper,
    .block-card-quote {
      @screen sm {
        @apply py-32;
      }
      .block-card {
        .block-card__divider {
          @apply hidden;
        }
        h3 {
          @apply text-center;
          @screen sm {
            @apply text-left;
          }
        }
      }
    }
    .block-card-wrapper {
      .block-card__container {
        .block-card__content {
          .block-card__content__container {
            @apply ml-auto;
          }
        }
      }
    }
  }
  &__text {
    @apply pt-16;
    @apply pb-32;
    @apply max-w-max;
    @apply mx-auto;
    @screen sm {
      @apply pt-24;
      @apply pb-48;
      @apply max-w-screen-sm;
    }
    h2,
    h3,
    h4,
    h5,
    h6 {
      @apply font-ginto-black;
    }
    h2 {
      font-size: calc(20px + (32 - 20) * (100vw - 640px) / (1920 - 640));
      @apply mb-8;
      @screen sm {
        @apply mb-8;
      }
    }
    p {
      @apply mb-8;
      font-size: calc(12px + (16 - 12) * (100vw - 640px) / (1920 - 640));
      &:last-of-type {
        @apply mb-0;
      }
      a {
        @apply border-b border-brand-blue;
        @apply pb-1;
      }
    }
    strong {
      @apply font-ginto-black;
    }
    ul {
      @apply list-disc;
      font-size: calc(12px + (16 - 12) * (100vw - 640px) / (1920 - 640));
      @apply py-8;
      li {
        @apply mb-8;
        &:last-of-type {
          @apply mb-0;
        }
      }
    }
  }
  &__image {
    @apply max-w-max mx-auto;
    img {
      @screen lg {
        max-width: 60vw;
      }
    }
    display: flex;
    justify-content: center;
  }
}
</style>
